import React, { Component } from "react";
import { Slider } from "antd";

class GrossMargin extends Component {
	constructor(props) {
		super(props);
		this.state= {
			x: (this.props.query===undefined || this.props.query["grossmargin"]=== undefined) ? [0,1]: this.props.query["grossmargin"].split('<=grossmargin; grossmargin<=').map(Number),
    	}
    	this.formatQueryRange(this.state.x);
  	}

	formatVal(value){
		// format tooltip for gross margin slider
		return `${value}`;
	}
	formatQueryRange(value){
		let formattedVal = value.join('<=grossmargin; grossmargin<=');
		this.props.buildSearchQuery('grossmargin', formattedVal);
	}
	render() {
		const marks = {
			0: '0%',
			1: '100%'
		}
		return (
			<section>
				<p className="panel-section-header">
					{this.props.queryTypeSingular}'s Gross Margin
				</p>
				<div>
					<Slider
						range
						marks={marks}
						step={0.01}
						min={0}
						max={1}
						tipFormatter={this.formatVal.bind(this)}
						defaultValue={this.state.x}
						onChange={this.formatQueryRange.bind(this)}
					/>
				</div>
			</section>
		);
	}
}

export default GrossMargin;


// WEBPACK FOOTER //
// ./src/components/Search/PanelLeft/AcquirorsOptions/GrossMargin/GrossMargin.js